import React, {Fragment} from 'react'
import styles from './TotalCalculator.scss'
import {Icon} from 'common/Icon'
import {contentLabel} from 'lib/styleguide/base.scss'
import moment from 'moment'
import cx from 'classnames'

export const TotalCalculator = ({
  accountLevelString,
  term,
  nextBillDate,
  quote,
  subscriptionCredit,
  discountLineItems,
  daysLeft,
  baseCost
}) => {
  return (
    <div className={styles.TotalCalculator}>
      {nextBillDate && <Fragment>
        <span>
          {accountLevelString === 'premium'
            ? <div className={styles.header}>
              <Icon i={'premium-arrow'} className={styles.premiumIcon} />
              <h3 className={cx(contentLabel, styles.text)}>premium</h3>
            </div>
            : <div className={styles.header}>
              <Icon i={'premium-arrow'} className={styles.basicIcon} />
              <h3 className={cx(contentLabel, styles.text)}>basic</h3>
            </div>}
        </span>
        <div className={styles.line} />

        <div className={styles.costRow}>
          {term === 'yearly'
            ? 'Annual '
            : 'Monthly '
          } cost
          <span>${baseCost}</span>
        </div>
        <div className={styles.line} />

        {subscriptionCredit > 0 && <span>
          <div className={cx(styles.costRow, styles.prorated)}>
          Prorated adjustment
            <span className={styles.prorate}>-${subscriptionCredit}</span>
          </div>
          <div className={styles.prorateTerm}>({[moment(), moment().add(daysLeft, 'days')].map((d) => d.format('MMM D, YYYY')).join(' - ')})</div>
          <div className={styles.line} />
        </span>}

        {discountLineItems && discountLineItems.map((item, idx) => (
          <span key={idx}>
            <div className={cx(styles.costRow, styles.prorated)}>
              {item.name}
              <span className={styles.prorate}>-{item.discount[accountLevelString][term]}%</span>
            </div>
            <div className={styles.prorateTerm}>{item.extra}</div>
            <div className={styles.line} />
          </span>
        ))}

        <div className={cx(styles.costRow, styles.total)}>
        Today's total
          <span>${quote}</span>
        </div>
        <div className={styles.line} />

        <div className={styles.footer}>
          <div>
            Your {accountLevelString === 'premium' ? 'Premium' : 'Basic'} subscription will renew at a {term} rate
            of ${discountLineItems ? quote : baseCost} on <b>{nextBillDate.format('MMMM D, YYYY')}</b>. <br />
          </div>
          <div className={styles.policy}>
            <span>
            We offer a 30 day money back guarantee. <br />
              <a href={'https://ridewithgps.com/privacy'}> Privacy Policy</a>
            </span>
          </div>
        </div>
      </Fragment>}
    </div>
  )
}
